import { Injectable } from '@angular/core';
import { CsabService } from '../../../shared/service/csab/csab.service';
import { ScpbService } from '../../../shared/service/scpb/scpb.service';
import { SucupiraService } from '../../../shared/service/sucupira/sucupira.service';
import { PessoaService } from '../../../shared/service/corporativo/pessoa.service';
import { ScppgServicosService } from '../../../shared/service/scppg/scppg-servicos.service';
import { selecionarProgramaPdaiVagas, chaveIdProgramaPdaiVagas } from '../../../shared/service/scppg/scppg-programa.helper';
import { AuthService } from '@sicapes/auth';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';
import {ScdocservicosService} from '../scdocservicos/scdocservicos.service';

@Injectable({
    providedIn: "root",
})
export class RegraIniciarInscricao {
    currentUser: any;

    constructor(
        private authService: AuthService,
        private csabService: CsabService,
        private scpbService: ScpbService,
        private sucupiraService: SucupiraService,
        private scdocservicosService: ScdocservicosService,
        private pessoaService: PessoaService,
        private scppgServicosService: ScppgServicosService,
        private toastr: ToastrService,
        private localStorageService: LocalStorageService,
    ) {
        this.authService.currentUser.subscribe(
            (x: any) => (this.currentUser = x),
        );
        this.localStorageService.set("mensagemErroIniciarInscricao", null);
    }

    public async validateInscricaoStart(parametrizacao: any): Promise<boolean> {

        const papelValido = await this.validarTipoPapelInscricao(parametrizacao);

        if (!papelValido) {
            return false;
        }

        // TODO: Implementar regras de negócio separadas por edital ou programa

        if (parametrizacao.in_docencia_proponente === 'S') {
            const msgErro = 'Para se inscrever neste edital é obrigatório ser docente ativo em algum PPG (Programa de Pós-Graduação)';
            try {
                const obterDocentePPGs = await this.sucupiraService
                    .obterDocentePPGs(this.currentUser.id)
                    .toPromise();

                // pega todas as chaves válidas, ignorando "_links"
                const registros = Object.keys(obterDocentePPGs)
                    .filter(key => key !== '_links');

                const possuiPPG = registros.some(key => {
                    const item = obterDocentePPGs[key];
                    return item.ppgs && item.ppgs.length > 0;
                });

                if (!possuiPPG) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgErro);
                    return false;
                }
            } catch (e) {
                this.localStorageService.set('mensagemErroIniciarInscricao', msgErro);
                return false;
            }
        }

        if (parametrizacao.in_titulo_doutorado_proponente === 'S') {
            const msgErro = 'O participante deve possuir título de doutor';
            try {
                const titulos = await this.pessoaService
                    .obterTitulos(this.currentUser.id)
                    .toPromise();

                const possuiDoutorado = titulos.some(
                    (titulo: any) =>
                        titulo.grau_academico?.id.toString() === '28' || titulo.grau_academico?.id.toString() === '31'
                );

                if (!possuiDoutorado) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgErro);
                    return false;
                }

            } catch (e) {
                this.localStorageService.set('mensagemErroIniciarInscricao', msgErro);
                return false;
            }
        }

        // validar inscricao NOVACAO
        if (parametrizacao.sg_programa_capes === "NOVACAO") {
            const novacaoResult = await this.csabService
                .obterNovacaoPessoa(this.currentUser.corporativo.id)
                .toPromise();

            if (novacaoResult.length > 0) {
                const processos: any[] = novacaoResult.filter(
                    (p) => p.podeSolicitarNovacao === true,
                );

                if (processos.length <= 0) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', 'Você não está apto para o Novação.');
                    return false;
                } else {
                    return true;
                }
            } else {
                this.localStorageService.set('mensagemErroIniciarInscricao', 'Você não está apto para o Novação.');
                return false;
            }
        } else if (
            ["PECPG2025", "PECPG2025DSW"].includes(parametrizacao.sg_edital)
        ) {
            const numeros = [
                14, 139, 25, 90, 2, 6, 12, 13, 21, 22, 24, 28, 30, 33, 34, 37,
                38, 43, 44, 46, 49, 50, 51, 53, 57, 58, 60, 69, 73, 74, 76, 84,
                86, 89, 91, 92, 94, 113, 116, 123, 132, 144, 147, 152, 154, 160,
                163, 165, 175, 177, 178, 179, 182, 186, 190, 191, 192, 204, 208,
                209, 210, 215, 222, 225, 227, 230, 231, 234, 235, 238, 242, 246,
                249,
            ];

            if (
                numeros.includes(this.currentUser.corporativo.nacionalidade.id)
            ) {
                // this.iniciar(parametrizacao);
                return true;
            } else {
                this.toastr.error(
                    "Você não possui a nacionalidade em um dos países indicados no edital.",
                );
                return false;
            }
        } else if (parametrizacao.sg_edital === "PROEB-CA-2026") {
            const msgError = 'Somente poderão participar deste edital os discentes que estejam regularmente matriculados no Programa de Pós-Graduação stricto sensu para Qualificação de Professores da Rede Pública da Educação Básica (ProEB)';
            const codigosValidos = [
                '25016016039P8',
                '33004137068P8',
                '23001011069P5',
                '33283010001P5',
                '41002016026P1',
                '40001016170P6',
                '31001017155P1',
                '31001017169P2',
                '33004129069P9',
                '31075010001P2',
                '32001010175P5',
                '42002010169P3',
                '33002045070P4',
                '43072003001P1',
                '12008010080P6',
            ];
            try {
                const obterDocentePPGs = await this.sucupiraService
                    .obterDiscente(this.currentUser.id)
                    .toPromise();
                if (obterDocentePPGs.length === 0) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgError);
                    return false;
                }
                const valido = Array.isArray(obterDocentePPGs._embedded.items) &&
                    obterDocentePPGs._embedded.items.some((item: any) =>
                        item.programa?.codigoPpg &&
                        codigosValidos.includes(item.programa.codigoPpg)
                    );
                if (!valido) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgError);
                    return false;
                }
            } catch (e) {
                this.localStorageService.set('mensagemErroIniciarInscricao', msgError);
                return false;
            }
            return true;

        } else if (parametrizacao.sg_edital === "POA-2026") {
            if (this.currentUser.id == null) {
                // this.exibirMensagem = true;
                let mensagem =
                    "Poderão participar do Chamamento Público somente os estudantes regularmente matriculados em programas de pós-graduação stricto sensu e devidamente registrados na Plaraforma Sucupira.";
                this.localStorageService.set("mensagemErroIniciarInscricao", mensagem);
                this.toastr.info(mensagem, "Atenção!", {
                    timeOut: 12000,
                });
                return false;
            }

            let tipoSituacaoMatriculado = 1;
            const discente = await this.sucupiraService
                .obterDiscente(this.currentUser.id, tipoSituacaoMatriculado)
                .toPromise();

            if (discente._embedded.items.length === 0) {
                let mensagem =
                    "Poderão participar do Chamamento Público somente os estudantes regularmente matriculados em programas de pós-graduação stricto sensu e devidamente registrados na Plaraforma Sucupira.";
                this.localStorageService.set("mensagemErroIniciarInscricao", mensagem);
                this.toastr.info(mensagem, "Atenção!", {
                    timeOut: 12000,
                });
                return false;
            }

            const setGraus = new Set([
                "Doutorado",
                "Mestrado",
                "Doutorado Profissional",
                "Mestrado Profissional",
                "Pós-doutorado",
            ]);
            let formacao =
                discente._embedded.items.filter((item) =>
                    setGraus.has(item.titulacao.grauAcademico.nome),
                )[0] === undefined
                    ? null
                    : discente._embedded.items.filter((item) =>
                          setGraus.has(item.titulacao.grauAcademico.nome),
                      )[0];

            if (formacao !== null) {
                return true;
            } else {
                let mensagem =
                    "Podem participar do Concurso apenas estudantes regularmente matriculados em programas de pós-graduação stricto sensu registrados na Plaraforma Sucupira.";
                this.localStorageService.set("mensagemErroIniciarInscricao", mensagem);
                this.toastr.info(
                    mensagem,
                    "Atenção!",
                    {
                        timeOut: 12000,
                    },
                );
                return false;
            }
        } else if (
            parametrizacao.sg_programa_capes === "PIPD-DRI" &&
            parametrizacao.sg_edital !== "PIPD-EXTERIOR"
        ) {
            try {
                const bolsas = await this.scpbService
                    .obterBolsas(this.currentUser.id)
                    .toPromise();

                if ("exception" in bolsas && "message" in bolsas) {
                    this.toastr.error(
                        "Serviço SCPBService com instabilidade, favor tente mais tarde.",
                    );
                    return false;
                }

                let hasPIPD = false;
                const bolsasScba = Array.isArray(bolsas) ? bolsas : [];

                if (bolsasScba.length <= 0) {
                    hasPIPD = false;
                }

                bolsasScba.forEach((e: any) => {
                    if (
                        e.edital === "PIPD-1/2024" &&
                        e.situacao !== "Acompanhamento - Arquivado"
                    ) {
                        hasPIPD = true;
                    }
                });

                const pagamentos = await this.scpbService
                    .obterPagamentos(this.currentUser.id)
                    .toPromise();
                const pagamentosScba = Array.isArray(pagamentos)
                    ? pagamentos
                    : [];
                const pgtos = pagamentosScba.filter(
                    (scba) => scba.programaCapes === "PIPD",
                );

                if (pgtos.length < 8) {
                    hasPIPD = false;
                }

                if (hasPIPD) {
                    return true;
                } else {
                    this.toastr.error(
                        "Você não tem os requisitos para participação neste edital (Não é beneficiário, ou não possui a quantidade de pagamentos necessários no edital PIPD - 1/2024).",
                    );
                    return false;
                }
            } catch (error) {
                this.toastr.error(
                    "Não foi possível obter dados do discente na Plartaforma Sucupira.",
                    "Atenção!",
                    {
                        timeOut: 12000,
                    },
                );
                return false;
            }

        } else if (parametrizacao.sg_edital === "PDAI-VAGAS") {
            const msgError = "Somente coordenadores de Programas de Pós-Graduação (PPG) de doutorado em pleno funcionamento na Plataforma Sucupira podem indicar vagas. Verifique a situação do seu PPG na Plataforma Sucupira.";
            const msgErrorNaoPrincipal = "Para se inscrever no edital PDAI-VAGAS sendo coordenador de Programa de Pós-Graduação em rede, é necessário que sua instituição seja a principal.";
            const msgErrorSemDoutorado = "Para se inscrever no edital PDAI-VAGAS é necessário coordenar um Programa de Pós-Graduação com curso de Doutorado ou Doutorado Profissional.";
            const msgErrorIndisponivel = "O sistema está com indisponibilidade momentânea. Por favor, tente novamente em alguns minutos.";
            const cpf = this.currentUser.id;

            try {
                const resposta = await this.scppgServicosService
                    .obterProgramasPorCoordenador(cpf)
                    .toPromise();

                const lista: any[] = (resposta && Array.isArray(resposta.programas))
                    ? resposta.programas
                    : [];
                if (lista.length === 0) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgError);
                    return false;
                }

                const {
                    programa: programaValido,
                    algumReprovouPorPrincipal,
                    algumReprovouPorMestradoOuDoutorado,
                } = selecionarProgramaPdaiVagas(lista);

                if (!programaValido) {
                    let mensagem = msgError;
                    if (algumReprovouPorPrincipal) {
                        mensagem = msgErrorNaoPrincipal;
                    } else if (algumReprovouPorMestradoOuDoutorado) {
                        mensagem = msgErrorSemDoutorado;
                    }
                    this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                    return false;
                }

                this.localStorageService.set(chaveIdProgramaPdaiVagas(cpf), programaValido.id);
            } catch (e: any) {
                const status = e?.status;
                if (status === 0 || status >= 500) {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgErrorIndisponivel);
                } else {
                    this.localStorageService.set('mensagemErroIniciarInscricao', msgError);
                }
                return false;
            }
        }
        return true;
    }

    private async validarTipoPapelInscricao(parametrizacao: any): Promise<boolean> {
        const tipoPapelInscricao = parametrizacao.tipo_papel_inscricao || parametrizacao.tp_papel_inscricao;

        if (!tipoPapelInscricao) {
            return true;
        }

        switch (String(tipoPapelInscricao)) {
            case '1':
                return await this.validarCoordenadorPrograma(parametrizacao);

            case '2':
                return await this.validarDiscente(parametrizacao);

            case '3':
                return await this.validarDocente();

            case '4':
                return await this.validarProReitor();

            default:
                return true;
        }
    }

    private async validarDiscente(parametrizacao: any): Promise<boolean> {
        const mensagem = 'Sua inscrição não pode ser iniciada, pois este edital é restrito a discentes matriculados em um programa de pós-graduação na Capes. Caso esteja matriculado em um PPG, solicite à coordenação do programa a verificação da situação do seu vínculo.';

        try {
            const tipoSituacaoMatriculado = 1;

            const resposta = await this.sucupiraService.obterDiscente(this.currentUser.id, tipoSituacaoMatriculado).toPromise();

            const cursos = Array.isArray(resposta?._embedded?.items) ? resposta._embedded.items : [];

            if (cursos.length === 0) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            const tipoGrauAcademico = Number(parametrizacao?.tp_grau_academico);

            const ID_MESTRADO = 27;
            const ID_DOUTORADO = 28;
            const ID_MESTRADO_PROFISSIONAL = 30;
            const ID_DOUTORADO_PROFISSIONAL = 31;

            const possuiMestrado = cursos.some((curso: any) => {
                const idGrauAcademico = curso?.titulacao?.grauAcademico?.id;
                return [ID_MESTRADO, ID_MESTRADO_PROFISSIONAL].includes(idGrauAcademico);
            });

            const possuiDoutorado = cursos.some((curso: any) => {
                const idGrauAcademico = curso?.titulacao?.grauAcademico?.id;
                return [ID_DOUTORADO, ID_DOUTORADO_PROFISSIONAL].includes(idGrauAcademico);
            });

            let possuiGrauPermitido = false;

            switch (tipoGrauAcademico) {
                case 1:
                    possuiGrauPermitido = possuiMestrado;
                    break;

                case 2:
                    possuiGrauPermitido = possuiDoutorado;
                    break;

                case 3:
                    possuiGrauPermitido =
                        possuiMestrado && possuiDoutorado;
                    break;

                default:
                    possuiGrauPermitido = false;
            }

            if (!possuiGrauPermitido) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            return true;
        } catch (e) {
            this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
            return false;
        }
    }

    private async validarDocente(): Promise<boolean> {
        const mensagem = 'Sua inscrição neste neste edital não pode ser iniciada, pois ele é restrito docentes ativos em algum programa de pós graduação na Capes.';

        try {
            const docentes = await this.scdocservicosService.obterDocentes(this.currentUser.id).toPromise();

            const registros = Object.keys(docentes).filter(key => key !== '_links');

            const possuiPPG = registros.some(key => {
                const item = docentes[key];
                return item.items && item.items.length > 0;
            });

            if (!possuiPPG) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            return true;
        } catch (e) {
            this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
            return false;
        }
    }

    private async validarCoordenadorPrograma(parametrizacao: any): Promise<boolean> {
        const mensagem = 'Sua inscrição neste edital não pode ser iniciada, pois você não atende aos requisitos para este edital.';

        try {
            const resposta = await this.scppgServicosService.obterProgramasPorCoordenador(this.currentUser.id).toPromise();

            const programas = resposta?.programas ?? [];

            // Sempre precisa possuir pelo menos um programa
            if (programas.length === 0) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            // Se o edital não exige coordenador principal, basta possuir programa
            if (parametrizacao?.in_coordenador !== 'S') {
                return true;
            }

            // Exige que exista algum agrupador marcado como principal
            const possuiPrincipal = programas.some((programa: any) =>
                programa.agrupadoresInstituicaoEnsino?.some((agrupador: any) => agrupador.principal === true)
            );

            if (!possuiPrincipal) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            return true;

        } catch {
            this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
            return false;
        }
    }

    private async validarProReitor(): Promise<boolean> {
        const mensagem = 'Sua inscrição neste neste edital não pode ser iniciada, pois ele é restrito a pró-reitores.';

        try {
            const possuiFuncao = this.currentUser?.corporativo?.funcoes?.some((funcao: any) => String(funcao.id) === '42');

            if (!possuiFuncao) {
                this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
                return false;
            }

            return true;
        } catch (e) {
            this.localStorageService.set('mensagemErroIniciarInscricao', mensagem);
            return false;
        }
    }
}
